import Swiper, {Navigation} from 'swiper';

export function initVariantSelectionSlider(query = document.querySelectorAll('.variantSelection .swiper')) {
    for (let itemlist of query) {
        Swiper.use([Navigation]);
        new Swiper(itemlist, {
            speed: 300,
            spaceBetween: 5,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            slidesPerView: "auto",
            slidesPerGroupAuto: true,
            navigation: {
                nextEl: itemlist.closest('.variantSelection').querySelector('.swiper-button-next'),
                prevEl: itemlist.closest('.variantSelection').querySelector('.swiper-button-prev'),
            }
        });
    }
}